import { Component, HostBinding } from '@angular/core';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { LoadingService } from './shared/services/loading.service';
import DataGrid, { Properties } from "devextreme/ui/data_grid";
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { DataGridConfigService } from './shared/services/dataGridConfigService ';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent {
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes)
      .filter((cl) => this.screen.sizes[cl])
      .join(' ');
  }

  constructor(
    private authService: AuthService,
    private screen: ScreenService,
    public appInfo: AppInfoService,
    public loadingService: LoadingService,
    private dataGridConfigService: DataGridConfigService
  ) {
    DataGrid.defaultOptions<Properties>({
      device: { deviceType: "desktop" },
      options: {
        remoteOperations: true, //sayfalamanın ajax çalışması için
        paging: { pageSize: 10 }, //defautl bir sayfada kaç satır olacak
        pager: { showPageSizeSelector: true, showInfo: true },
        sorting: { mode: 'multiple' }, //çoklu kolon sıralama
        filterRow: { visible: true }, //filtreleme özelliği aktif pasif
        columnChooser: { enabled: false }, //hangi kolonların görüneceğini kullanıcı seçsğin veya seçmesin
        showBorders: true,
        columnAutoWidth: true,
        columnHidingEnabled: false, //ekrana sığmayan kolonlar 3 nokta ile detayda mı görüntülensin yoksa scroll mu çıksın
        export: { enabled: true },
        onExporting: this.onExporting.bind(this)
      }
    });
  }

  onExporting(e: DxDataGridTypes.ExportingEvent) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Liste');
    const gridId = this.dataGridConfigService.getGridExportName();

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${gridId}.xlsx`);
      });
    });
  }


  isAuthenticated() {
    return this.authService.loggedIn;
  }
}

